module.exports = "/_next/static/images/top-4a3f79aa213f88f8c99febdef9590c85.jpg";